// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3glop","content":"style_content__1wTM_"};